/**
 * The Lumnian mark.
 *
 * Uses the navy-tile artwork rather than a transparent cut-out on purpose: the
 * logo's rays and wordmark are white, so a transparent mark disappears against
 * the white nav bar in light mode. The tile carries its own background and so
 * reads correctly on any surface.
 */

interface LogoProps {
  /** Rendered size in px. The artifact is 128px, so anything up to 64 stays crisp. */
  size?: number;
  className?: string;
}

export default function Logo({ size = 28, className = '' }: LogoProps) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo-tile.png`}
      width={size}
      height={size}
      // Empty alt already takes it out of the a11y tree — it's decorative next
      // to the wordmark — and the width/height attributes reserve layout before
      // the artifact loads, so neither needs restating in a style prop.
      alt=""
      className={`flex-shrink-0 rounded-md ${className}`.trim()}
    />
  );
}
